import * as gateway from 'sfx-web-contract';
import { AlkLogger } from '@alk/core';
import { convertToProtobufOrderSide, convertToProtobufSpotType } from '../../../helpers/protobuf';
import { DeepRequired } from '../../../types';
import { fromGatewayPoint, fromGatewayPrice } from '../stream-adapter-utils/stream-adapter-utils';
import { IQuote, ISpotQuote, IStreamData, SpotPriceRequestWithClient } from '../../../interfaces';

export function encodeSpotQuoteRequest(request: SpotPriceRequestWithClient): Uint8Array {

    const req: DeepRequired<gateway.ISpotQuoteRequest> = {
        ClientId: request.clientId,
        Quantity: request.quantity,
        QuantitySecondLeg: { value: request.quantitySecondLeg },
        Instrument: request.ccyPair,
        BaseCurrency: request.tradedCurrency,
        SpotType: convertToProtobufSpotType(request.spotType),
        Side: Boolean(request.side) ? convertToProtobufOrderSide(request.side) : undefined,
        Price: { value: request.price },
    };

    const quoteRequest = gateway.SpotQuoteRequest.create(req);

    return gateway.SpotQuoteRequest.encode(quoteRequest).finish();
}

export function decodeSpotQuoteResponse({ payload, communicationToken: requestId }: IStreamData<Uint8Array>): ISpotQuote {

    try {
        const response = gateway.SpotQuoteResponse.decode(payload);

        return response.SpotQuotes.map((spotQuote) => fromGatewaySpotQuotes(spotQuote, requestId));
    } catch (error) {
        AlkLogger.error(`[SPOT_STREAM_ADAPTER] Decoding error ${ payload } not decode to SpotQuoteResponse message`);
        throw error;
    }
}

export function fromGatewaySpotQuotes(spotQuote: gateway.ISpotQuote, requestId: number): IQuote {
    return {
        productType: 'Spot',
        askPrice: fromGatewayPrice(spotQuote.AskPrice),
        bidPrice: fromGatewayPrice(spotQuote.BidPrice),
        spotSpread: fromGatewayPoint(spotQuote.Spread),
        askTimestamp: spotQuote.OfferTimeStamp as number,
        bidTimestamp: spotQuote.BidTimeStamp as number,
        requestId,
    };
}
